import refreshAttribute from '../utils/refreshAttribute'
import Player from '@vimeo/player'

export default {
  name: 'video-modal',

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault()
        if (!this.el.getAttribute('js-modal-control')) {
          this.createModal()
        } else {
          this.insertVideo()
        }
      },
    },
  ],

  componentDidMount () {
  },

  createModal (data) {
    const node = document.createElement('div')
    node.classList.add('modal', 'modal--video', 'is-hidden')
    node.id = `video-${this.props.id}`
    node.setAttribute('js-modal', '')

    // node.appendChild(stringToHTML(data))
    node.innerHTML = `
      <div class="modal__video">
        <button class="modal__close modal__close--white center-content" js-modal-close>
          <span class="sr-only">Fermer</span>
          <svg width="24" height="24" class="icon--white">
              <use href="#icon-close" xlink:href="#icon-close"></use>
          </svg>
        </button>
        <div class="modal__video-inner"></div>
      </div>`

    this.el.setAttribute(
      'js-modal-control',
      `{'target': '#video-${this.props.id}'}`,
    )

    document.querySelector('.modals').appendChild(node)

    node.querySelector('.modal__close').addEventListener('click', () => {
      this.stopVideo()
    })

    node.addEventListener('click', () => {
      this.stopVideo()
    })

    if (this.props.refreshAttribute) {
      this.props.refreshAttribute.forEach(el => {
        if (node.querySelector(`[${el}]`)) refreshAttribute(el)(node.querySelector(`[${el}]`))
      })
    }

    setTimeout(() => {
      this.el.click()
    }, 300)
  },

  stopVideo () {
    if (this.props.type !== 'undefined' && this.props.type === 'vimeo') {
      this.vimeo.pause()
      this.vimeo.setCurrentTime(0)
    }
  },

  insertVideo () {
    const modalVideo = document.querySelector(`#video-${this.props.id} .modal__video-inner`)

    if (this.props.type !== 'undefined' && this.props.type === 'youtube') {
      modalVideo.innerHTML = `
          <lite-youtube class="mx-auto" videoid="${this.props.id}">
          </lite-youtube>`

      modalVideo.querySelector('lite-youtube').click()
    } else {
      modalVideo.classList.add('is-vimeo')

      this.vimeo = new Player(modalVideo, {
        id: this.props.id,
        width: 640,
      })

      this.vimeo.play()
    }
  },
}
